export default __webpack_public_path__ + "assets/models/fa82f79be0f87639a6c968da0aed077a.glb";